import { cloneDeep } from 'lodash';
import {
  initialPlaycastData,
  PlaycastData,
  // PlaycastPeerManager,
  // PlaycastPeerManager,
  PlaycastPlayerConnection,
} from './types';
import type { DataConnection, MediaConnection } from 'peerjs';
import { PlaycastVector } from '@playcastdotio/CoreTypes';
import { captureStore } from '@playcastdotio/InputCapture';
import { sendMetricPlayerChangeMode } from '../../metrics';
import { hostConnectionState } from '../../api/stores';

const refreshed = new Event('playcastDataRefreshed');
const videoDimensionsUpdated = new Event('playcastVideoDimensionsUpdated');
const dataConnectionChanged = new CustomEvent('playcastDataConnectionChanged');
const mediaConnectionChanged = new CustomEvent('playcastMediaConnectionChanged');

const playcastData: PlaycastData = cloneDeep(initialPlaycastData);
const userAgent = navigator.userAgent.toLowerCase();
playcastData.device = {
  userAgent: userAgent,
  isMobile: /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent),
  isTablet: /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent),
  isDesktop: !/iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent),
};

const getData = () => {
  return playcastData;
};

// const updatePlayerConnection = (connection: PlaycastPlayerConnection) => {
//   playcastData.connection = connection;
//   sessionStorage.hostId = connection.host.id;
//   dispatchEvent(refreshed);
// };

const updateVideoDimensions = (dimensions: PlaycastVector) => {
  playcastData.video.dimensions = { ...dimensions };
  dispatchEvent(refreshed);
  dispatchEvent(videoDimensionsUpdated);
};

// const updatePeerManager = (peerManager: PlaycastPeerManager) => {
//   playcastData.peerManager = peerManager;
//   dispatchEvent(refreshed);
// };

// const updatePeerId = (id: string) => {
//   playcastData.peerManager.id = id;
//   dispatchEvent(refreshed);
// };

// const updatePeerState = (state: string) => {
//   playcastData.peerState.peerState = state;
//   dispatchEvent(refreshed);
// };

// const updatePeerData = (connection: DataConnection) => {
//   playcastData.peerState.data = connection;
//   dispatchEvent(refreshed);
// };

// const updatePeerDataConnectionState = (state: string) => {
//   playcastData.peerState.dataConnectionState = state;
//   console.log("data connection state: ", state);
//   dispatchEvent(refreshed);
//   dispatchEvent(dataConnectionChanged);
// };

// const updatePeerMedia = (connection: MediaConnection) => {
//   playcastData.peerState.media = connection;
//   dispatchEvent(refreshed);
// };

// const updatePeerMediaConnectionState = (state: string) => {
//   playcastData.peerState.mediaConnectionState = state;
//   dispatchEvent(refreshed);
//   dispatchEvent(mediaConnectionChanged);
// };

// const updatePeerId = (id: string) => {
//   playcastData.peerManager = {
//     ...(playcastData.peerManager || {}),
//     id: id,
//   } as PlaycastPeerManager;
//   dispatchEvent(refreshed);
// };

// const updatePeerState = (state: string) => {
//   playcastData.peerManager = {
//     ...(playcastData.peerManager || {}),
//     peerState: state,
//   } as PlaycastPeerManager;
//   dispatchEvent(refreshed);
// };

// const updatePeerData = (connection: DataConnection) => {
//   playcastData.peerManager = {
//     ...(playcastData.peerManager || { id: '' }),
//     data: connection,
//   } as PlaycastPeerManager;
//   dispatchEvent(refreshed);
// };

// const updatePeerDataConnectionState = (state: string) => {
//   playcastData.peerManager = {
//     ...(playcastData.peerManager || { id: '' }),
//     dataConnectionState: state,
//   } as PlaycastPeerManager;
//   dispatchEvent(refreshed);
//   dispatchEvent(dataConnectionChanged);
// };

// const updatePeerMedia = (connection: MediaConnection) => {
//   playcastData.peerManager = {
//     ...(playcastData.peerManager || { id: '' }),
//     media: connection,
//   } as PlaycastPeerManager;
//   dispatchEvent(refreshed);
// };

// const updatePeerMediaConnectionState = (state: string) => {
//   playcastData.peerManager = {
//     ...(playcastData.peerManager || { id: '' }),
//     mediaConnectionState: state,
//   } as PlaycastPeerManager;
//   dispatchEvent(refreshed);
//   dispatchEvent(mediaConnectionChanged);
// };

const updatePlayerOptionsOpen = (open: boolean) => {
  playcastData.options.open = open;
  updatePlayerMobileGamepad(true);
  dispatchEvent(refreshed);
};

const updateGamepadMode = () => {
  playcastData.mode.useGamepadAsMouse = !playcastData.mode.useGamepadAsMouse;
  dispatchEvent(refreshed);
};

const playerModeAllowed = (): boolean => {
  const access = captureStore.getAccess();
  return !!(access.gamepad || access.keyboard || access.mouse || access.touch);
};

let cachedPlayerMode = '';

const updatePlayerMode = (mode: 'spectator' | 'player') => {
  if (hostConnectionState.currentState?.status !== 'connected') return;
  console.log(mode);
  console.log(playerModeAllowed());
  if (mode !== cachedPlayerMode) {
    sendMetricPlayerChangeMode(mode);
  }
  cachedPlayerMode = mode;
  playcastData.mode.mode = mode;
  if (mode === 'player') playcastData.options.open = false;
  if (mode === 'spectator' && playerModeAllowed()) {
    playcastData.options.open = true;
  }
  updatePlayerMobileGamepad(true);
  dispatchEvent(refreshed);
  // const sessionId = playcastData.connection.host.id;
};

const shouldShowMobileGamepad = (): boolean => {
  const access = captureStore.getAccess();
  if (playcastData.device.isMobile || playcastData.device.isTablet) {
    console.log('ismobile or istablet - in shouldShowMobileGamepad');
    if (access.gamepad) {
      console.log('gamepad access - in shouldShowMobileGamepad');
      if (playcastData.mode.mode === 'player') {
        console.log('player mode - in shouldShowMobileGamepad');
        if (playcastData.gamepad.gamepads.filter((g) => !!g).length === 0) {
          console.log('no gamepads - in shouldShowMobileGamepad');
          return true;
        }
      }
    }
  }
  return false;
};

const isPhysicalGamepadConnected = (): boolean => {
  return playcastData.gamepad.gamepads.filter((g) => !!g).length > 0;
};

const updatePlayerMobileGamepad = (skipRefresh?: boolean) => {
  playcastData.mode.useMobileGamepad = shouldShowMobileGamepad();
  if (!skipRefresh) dispatchEvent(refreshed);
};

export const store = {
  getData,
  refreshed,
  videoDimensionsUpdated,
  dataConnectionChanged,
  mediaConnectionChanged,
  updateVideoDimensions,
  updatePlayerOptionsOpen,
  playerModeAllowed,
  updatePlayerMode,
  updatePlayerMobileGamepad,
  isPhysicalGamepadConnected,
  updateGamepadMode,
};
